export default __webpack_public_path__ + "static/Infocards_Default-9a70c2aa3d825f86b3326e746b1f3cdd.png";